import { usePortal } from './usePortalContext';

export const useConfirmation = (Component: React.ComponentType<any>): ((props?: any) => Promise<any>) => {
  const { renderComponent, clearComponent } = usePortal();

  return async (props?: any): Promise<any> => {
    const dispose = (): void => {
      clearComponent();
    };

    const promise = new Promise((resolve, reject) => {
      const handleConfirm = (value: any): void => {
        resolve(value);
      };
      const handleReject = (value: any): void => {
        reject(value);
      };

      // Render the dialog dynamically
      renderComponent(<Component {...props} open={true} confirm={handleConfirm} reject={handleReject} />);
    });

    return await promise.then(
      (result) => {
        dispose();
        return result;
      },
      (reason) => {
        dispose();
        return reason;
      },
    );
  };
};
